import { Modal, ModalBody, ModalContent } from "@nextui-org/react"
import MoreMenu from "views/MoreMenu"

export default function MoreModal({ isOpen, setIsOpen }) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      size="full"
      radius="none"
      className="bg-background"
      classNames={{
        base: "m-0 flex flex-col max-w-[820px] md:max-w-[500px]",
        wrapper: "sm:items-end",
        closeButton:
          "z-50 bg-[var(--button-bg-color)] text-[var(--button-text-color)]",
      }}
    >
      <ModalContent>
        {(onClose) => (
          <ModalBody className={"overflow-hidden"}>
            <MoreMenu onSelect={() => setIsOpen(false)} />
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  )
}
